import React, { useState, useEffect } from "react";
import Preloader from "../src/components/Pre";
import Home from "./components/About/About";
import Experience from "./components/Work/Experience";
import Projects from "./components/Projects/Projects";
import {
  BrowserRouter as Router,
  Route,
  Routes,
  Navigate
} from "react-router-dom";
import "./style.css";
import "./App.css";
import "bootstrap/dist/css/bootstrap.min.css";
import ECanteen from "./components/Projects/ECanteen";
import Hope from "./components/Projects/Hope";
import VideoChat from "./components/Projects/VideoChat";
import TruliaCareInsights from "./components/Work/TruliaCareInsights";
import Lookbook from "./components/Work/Lookbook";
import KratinPortal from "./components/Work/KratinPortal";
import KratinSM from "./components/Work/KratinSM";
import ScrollToTop from "react-scroll-to-top";
import ScrollToTop1 from "./components/ScrollToTop";
import CustomCursor from "./components/CustomCursor";
import Contact from "./components/Contact/Contact";
import ECommerce from "./components/Projects/ECommerce";
import Adwyzors from "./components/Projects/Adwyzors";
function App() {
  const [load, upadateLoad] = useState(true);

  useEffect(() => {
    const timer = setTimeout(() => {
      upadateLoad(false);
      window.scrollTo(0,0);
    }, 2000);

    

    return () => clearTimeout(timer);
  }, []);

  return (
    <Router>
      <Preloader load={load} />
      <ScrollToTop1 />
      <CustomCursor />
      <div className="App" id={load ? "no-scroll" : "scroll"}>
        
        
        <ScrollToTop smooth/>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/project" element={<Projects />} />
          <Route path="/project/ecanteen" element={<ECanteen />} />
          <Route path="/project/ecommerce" element={<ECommerce />} />
          <Route path="/project/healthpredictor" element={<Hope />} />
          <Route path="/project/adwyzors" element={<Adwyzors />} />
          <Route path="/project/videochat" element={<VideoChat />} />
          
          <Route path="/experience" element={<Experience />} />
          <Route path="/experience/truliacareinsights" element={<TruliaCareInsights />} />
          <Route path="/experience/monalis" element={<Lookbook />} />
          <Route path="/experience/kratinportal" element={<KratinPortal />} />
          <Route path="/experience/kratinbranding" element={<KratinSM />} />

          <Route path="/contact" element={<Contact />} />
          <Route path="*" element={<Navigate to="/"/>} />
        </Routes>
        {/* <Footer /> */}
      </div>
    </Router>
  );
}

export default App;
